import { Doughnut } from 'react-chartjs-2';
import { accountingFormatNumber, getLastSevenDays } from '../../../../utils';
import { Chart, ChartTypeRegistry, LegendItem } from 'chart.js';

export default function DoughnutChart({
  dataLabels,
  colors,
  datasets,
  display = true,
  percentage = false,
}: {
  dataLabels: string[];
  colors?: boolean;
  datasets: { data: number; color: string }[];
  display?: boolean;
  percentage?: boolean;
}) {
  const lastSevendaysFormatted: string[] = [];
  getLastSevenDays().forEach((date) => {
    lastSevendaysFormatted.push(date.toDateString());
  });

  const barCount = Math.floor(Math.random() * (10 - 5) + 5);
  const randomData = [];
  for (let i = 0; i < dataLabels?.length; i++) {
    randomData.push(Math.floor(Math.random() * (100 - 1) + 1));
  }

  const userData: any = [];
  const dataColors: string[] = [];
  datasets?.forEach((d) => {
    userData.push(d.data);
    dataColors.push(d.color);
  });

  return (
    <>
      <Doughnut
        className='p-8'
        id='chart'
        data={{
          labels: dataLabels,
          datasets: [
            {
              label: '',
              data: userData,
              backgroundColor: dataColors,
            },
          ],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: true,
          plugins: {
            legend: {
              position: 'bottom',
              align: 'start',
              display: display,
              labels: {
                usePointStyle: true,
                font: { size: 16 },
                pointStyle: 'circle',
                padding: 20,
                generateLabels: (
                  chart: Chart<
                    keyof ChartTypeRegistry,
                    (number | null)[],
                    unknown
                  >
                ): LegendItem[] => {
                  const { data } = chart;
                  if (data?.labels?.length) {
                    return data.labels.map((label, i) => ({
                      text: `${label}: ${
                        percentage ? (
                          `${data?.datasets[0]?.data[i]}%`
                        ) : (
                          accountingFormatNumber({
                            num: data?.datasets[0]?.data[i]!,
                            format: 'en-US',
                            currency: 'USD',
                          })
                        )
                      }`,
                      fillStyle: dataColors[i],
                      strokeStyle: dataColors[i],
                      lineWidth: 2,
                      datasetIndex: 0,
                    }));
                  }
                  return [];
                },
              },
            },
          },
        }}
      />
    </>
  );
}
